import { Injectable } from '@angular/core';
import { CouponStatusInfo } from 'src/app/shared/models/model/couponStatusInfo/coupon-status-info';

@Injectable({ providedIn: 'root' })
/**
 * Service to deal with coupon card component
 */
export class CouponCardService {
  couponStatuses: CouponStatusInfo[] = [];

  /**
   *
   * @param {number} couponId
   */
  removeCouponStatusById(couponId: number) {
    const updatedArr = this.couponStatuses.filter(
      (item) => item.couponId !== couponId
    );

    this.couponStatuses = updatedArr;
  }

  /**
   *
   * @param {number} couponId
   * @return {CouponStatus}
   */
  findCouponStatusById(couponId: number) {
    return this.couponStatuses.find(
      (item) => item.couponId === couponId
    ) as CouponStatusInfo;
  }
}
